import isPlainObject from 'lodash/isPlainObject';

type ObjectType = Record<string, unknown> | Array<ObjectType>;
/**
 * This function will remove all the key with null value in an object
 * @constructor
 * @param {object} obj - The object that you want to remove null value.
 */
export function objectRemoveEmptyDeep(obj: ObjectType): ObjectType {
  if (Array.isArray(obj)) {
    return obj.map((item) => objectRemoveEmptyDeep(item)).filter((item) => item !== null);
  } else if (isPlainObject(obj)) {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([, v]) => v !== null)
        .map(([k, v]) => [
          k,
          isPlainObject(v) || Array.isArray(v) ? objectRemoveEmptyDeep(v as ObjectType) : v,
        ]),
    );
  } else {
    return obj;
  }
}
